/**
 * Material button type mapping
 */
export const type_mapping_seeker = {
    1: "chat_bubble",
    2: "update",
    3: "pet_supplies"
}

/**
 * Material button type mapping
 */
export const type_mapping_shelter = {
    1: "chat_bubble",
    2: "assignment",
    3: "reviews",
    4: "rating"
}